export interface getLandingPageReportsAsyncPayload {
    start_date: string;
    end_date: string;
}

export interface getLandingPageVisitsAsyncPayload {
    start_date: string;
    end_date: string;
}

export interface getLandingPageDetailVisitsAsyncPayload {
    id: number;
    start_date: string;
    end_date: string;
}

export interface LandingPageReportsState {
    isReportsLoading: boolean;
    landingPageReports: null | Array<{
        date: string;
        total_visit: number;
    }>;
}

export interface LandingPageVisitsState {
    isVisitsLoading: boolean;
    landingPageVisits: null | Array<{
        id: number;
        name: string;
        created_at: string;
        total_visit: string;
    }>;
}

export interface LandingPageDetailVisitsState {
    isDetailLoading: boolean;
    landingPageDetailVisits: null | Array<{
        date: string;
        total_visit: number;
    }>;
}

export interface LandingPageReportsState {
    isReportsLoading: boolean;
    landingPageReports: null | Array<{
        date: string;
        total_visit: number;
    }>;
}

export interface LandingPageVisitsState {
    isVisitsLoading: boolean;
    landingPageVisits: null | Array<{
        id: number;
        name: string;
        created_at: string;
        total_visit: string;
    }>;
}

export interface LandingPageDetailVisitsState {
    isDetailLoading: boolean;
    landingPageDetailVisits: null | Array<{
        date: string;
        total_visit: number;
    }>;
}

export const initialState: LandingPageReportsState &
    LandingPageVisitsState &
    LandingPageDetailVisitsState = {
    //Chart
    isReportsLoading: false,
    landingPageReports: null,

    //Visits
    isVisitsLoading: false,
    landingPageVisits: null,

    // Detail
    isDetailLoading: false,
    landingPageDetailVisits: null,
};
